<script lang="ts">
  import SettingsPricingDetails from "@modern/components/retailer/settings/Pricing/Details.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    let res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_integrated: true,
      },
    });

    let res2 = await HttpPromise({
      method: "GET",
      url: "/api/retailer/custom_prices",
      data: {
        distributor_id: $params["distributorId"],
      },
    });
    return { distributors: res, customPrices: res2 };
  };
</script>

{#await load()}
  <Spinner />
{:then data}
  <SettingsPricingDetails
    distributors={data.distributors}
    customPrices={data.customPrices}
    distributorId={$params["distributorId"]}
    productSearch={$params["productSearch"]}
  />
{/await}
